import { render } from "./TakePhoto.vue?vue&type=template&id=8dc9149c&scoped=true"
import script from "./TakePhoto.vue?vue&type=script&lang=js"
export * from "./TakePhoto.vue?vue&type=script&lang=js"

import "./TakePhoto.vue?vue&type=style&index=0&id=8dc9149c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc9149c"]])

export default __exports__